import FieldsCollection from "../../fields3/collection/base/fields-collection";
import {EntityType} from "../../gd/const/item";
import {FieldType} from "../../fields3/field-type";
import FieldColor from "../../fields3/generic/color/color";


const baseConfig = [
    {
        fieldId : 'title',
        type    : FieldType.STRING,
        label   : 'Note title'
    },
    {
        fieldId: 'momentCreated',
        type: FieldType.MOMENT,
        clearButton: false
    },
    {
        fieldId: 'lastUpdated',
        type: FieldType.MOMENT,
        clearButton: false
    },


    {
        fieldId: 'contentText',
        type: FieldType.TEXT
    },

    {
        fieldId: 'contentRtf',
        type: FieldType.TEXT
    },

    {
        fieldId     : 'type',
        type        : FieldType.NUMBER
    },

    {
        fieldId     : 'color',
        type        : FieldType.COLOR,
        label       : 'Notepad color'
    }
]

export default class NotepadFields extends FieldsCollection {


    // Quick access

    // get userId()                : FieldUser { return this.get('userId') as FieldUser }
    // get momentCreated()         : FieldMoment { return this.get('momentCreated') as FieldMoment}
    // get date()                  : FieldDate { return this.get('date') as FieldDate }
    // get reportedTimeMinutes()   : FieldTaskTimeReported { return this.get('reportedTimeMinutes') as FieldTaskTimeReported}
    // get message()               : FieldText { return this.get('message') as FieldText }
    // get taskId()                : FieldText { return this.get('taskId') as FieldText }
    get color()                     : FieldColor { return this.get('color') as FieldColor }

    constructor() {
        super(baseConfig, EntityType.NOTEPAD);
    }


}
